import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-beneficio-esquerda',
  templateUrl: './beneficio-esquerda.component.html',
  styleUrls: ['./beneficio-esquerda.component.scss']
})

export class BeneficioEsquerdaComponent implements OnInit {
  @Input() data;

  constructor() {
  }

  ngOnInit() {
  }

}
